// Copyright (c) 2016 Deere & Company

const stolenStatuses = [
    'STL1',
    'STLP'
];

export default stolenStatuses;



// WEBPACK FOOTER //
// ./src/product/status-change-request/utils/stolen-statuses.js